import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/holibob/holibob/booking-web/containers/Page/Page.tsx");
